import { useNavigate } from "react-router-dom";
import Button from "../Button";
import { ArrowBigRightIcon } from "lucide-react";

interface ActionLinkButtonProps {
  linkTo: string;
  operationKlassToCheckPermission?: string;
  dataTestid?: string;
}

const ActionLinkButton = ({ linkTo, operationKlassToCheckPermission, dataTestid }: ActionLinkButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="link-white"
      operationKlassToCheckPermission={operationKlassToCheckPermission}
      className="w-full"
      onClick={() => navigate(linkTo)}
      dataTestId={dataTestid}
    >
      <ArrowBigRightIcon className="w-full" />
    </Button>
  )
}

export default ActionLinkButton;
